module.exports = __webpack_public_path__ + "static/media/tracy_06.dc7d9150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_06.jpg
// module id = 384
// module chunks = 0